import styled, { css } from 'styled-components';

interface LinkStateProps {
  soon?: boolean;
  new?: boolean;
}

interface ContainerProps {
  colorLeft?: string;
  colorRight?: string;
}

const Container = styled.a<ContainerProps>`
  position: relative;
  width: 40%;
  background: linear-gradient(
    135deg,
    ${(props) => props.colorLeft} 0%,
    ${(props) => props.colorRight} 100%
  );
  box-shadow: 0 0 2rem rgba(0, 0, 0, 0.2);
  border-radius: 0.8rem;
  margin: 1.8rem 0;
  padding: 2rem 0;
  text-decoration: none;
  transition: 0.5s;

  &:hover {
    background-color: #7bd6dc;
  }

  display: flex;
  flex-direction: column;
  align-items: center;

  > h1 {
    margin-top: 1rem;
    font-size: 1.8rem;
    font-weight: 400;
    color: #fff;
    text-shadow: 0.2rem 0.2rem #20202020;
  }

  @media (min-width: 768px) {
    width: 35rem;
  }
`;

const LinkState = styled.div<LinkStateProps>`
  position: absolute;
  right: -1rem;
  top: -1.5rem;
  padding: 0.3rem 0.5rem;
  border-radius: 0.5rem;

  > h2 {
    font-size: 1.4rem;
    color: #fff;
  }

  ${(props) =>
    props.soon &&
    css`
      background-color: #ff6969;
    `}

  ${(props) =>
    props.new &&
    css`
      background-color: #00a0b6;
    `}
`;

export { Container, LinkState };
